
























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { DeviceCategoryTemplate } from "@/data/models/DeviceCategoryTemplate";
import { COLOR_ALL_DEVICES_DELETE_ICON, COLOR_ALL_DEVICES_EDIT_ICON, COLOR_ALL_DEVICES_FOLDER_ICON } from "@/utils/colors";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import ClientPanel from "@/data/models/ClientPanel";
import { GenericDeviceFilter } from "@/data/models/DeviceFilter";
import { formatNumber } from "@/utils/Utils";
import { getFormattedDeviceString } from "@/utils/DeviceManagementUtils";

@Component({})

export default class DeviceCategoryItem extends Vue {
  @Prop()
  deviceCategory!: DeviceCategoryTemplate;

  @Prop()
  devices!: DeviceOverview[] | ClientPanel[];

  @Prop() elevation!: number;

  @Prop()
  isDefaultBranchFilterSelected!: boolean;

  @Prop({ default: "" })
  backgroundStyle!: string;

  @Prop({ default: false })
  displayCategoryContent: boolean;

  @Prop({ default: false })
  isEditable: boolean;

  @Prop({ default: false })
  isRemovable: boolean;

  @Prop({ default: "mdi-folder" })
  iconResource: string;

  @Prop()
  noOfTotalDevices!: number;

  @Prop()
  selectedDeviceFilter!: GenericDeviceFilter;

  get colorEditIcon() {
    return COLOR_ALL_DEVICES_EDIT_ICON;
  }

  get colorDeleteIcon() {
    return COLOR_ALL_DEVICES_DELETE_ICON;
  }

  get categoryTitle() {
    const categoryName = this.deviceCategory ? this.deviceCategory.categoryName : this.$t("common.all").toString();
    const noOfDevicesString = this.selectedDeviceFilter !== GenericDeviceFilter.ALL_DEVICES ||
    !this.isDefaultBranchFilterSelected
        ? formatNumber(this.devices.length) + "/" + formatNumber(this.noOfTotalDevices)
        : formatNumber(this.devices.length);

    const deviceTemplates = this.deviceCategory ? this.deviceCategory.deviceTemplates.length : 0;

    const allDevicesTitle = " (" + noOfDevicesString + ")";

    const deviceTemplatesString = getFormattedDeviceString(this, deviceTemplates, "overview.deviceTypes");
    const devicesString = getFormattedDeviceString(this, this.devices.length, "overview.devices");

    const categoryContentTitle = ` (${deviceTemplatesString}, ${devicesString})`;

    return categoryName + (this.displayCategoryContent ? categoryContentTitle : allDevicesTitle);
  }

  @Emit("onEditCategory")
  onEditCategory() {
    this.$emit("onEditCategory", this.deviceCategory.id);
  }

  @Emit("onDeleteCategory")
  onDeleteCategory() {
    this.$emit("onDeleteCategory", this.deviceCategory.id);
  }

  get iconColor() {
    return COLOR_ALL_DEVICES_FOLDER_ICON;
  }

  get showCategory() {
    return (this.selectedDeviceFilter === GenericDeviceFilter.ALL_DEVICES &&
            this.isDefaultBranchFilterSelected) ||
        this.devices.length > 0;
  }

  onOpenDeviceCategory() {
    this.$emit("onOpenDeviceCategory");
  }
}
